/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type CsmSettingsType from '@jira/spa-apps__project-settings-csm/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyCsmSettings: LazyComponent<() => React.JSX.Element | null> = lazyForPaint<
	typeof CsmSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-csm", jiraSpaEntry: "async-project-settings-csm" */ '@jira/spa-apps__project-settings-csm/src/index.tsx'
		),
	),
);

const AsyncCsmSettings = (): React.JSX.Element => (
	<LazyPage Page={LazyCsmSettings} pageId="project-settings-csm" shouldShowSpinner={false} />
);

export default AsyncCsmSettings;
